
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Reveal } from './Reveal';

export const ProcessTimeline: React.FC = () => {
  const { t } = useTranslation();

  const steps = [
    {
      id: "01",
      titleKey: "process.steps.audit.title",
      subtitleKey: "process.steps.audit.subtitle",
      descKey: "process.steps.audit.desc",
    },
    {
      id: "02",
      titleKey: "process.steps.architecture.title",
      subtitleKey: "process.steps.architecture.subtitle",
      descKey: "process.steps.architecture.desc",
    },
    {
      id: "03",
      titleKey: "process.steps.orchestration.title",
      subtitleKey: "process.steps.orchestration.subtitle",
      descKey: "process.steps.orchestration.desc",
    },
    {
      id: "04",
      titleKey: "process.steps.deployment.title",
      subtitleKey: "process.steps.deployment.subtitle",
      descKey: "process.steps.deployment.desc",
    }
  ];

  return (
    <section id="process" className="py-20 md:py-40 bg-gray-50 relative overflow-hidden">
      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <Reveal>
          <div className="mb-20 md:mb-32 text-center">
            <h2 className="text-4xl md:text-6xl font-bold mb-6 text-gray-900 tracking-tight">{t('process.title')}</h2>
            <div className="h-1 w-20 bg-clever-teal mx-auto"></div>
          </div>
        </Reveal>

        <div className="relative">
          <div className="absolute left-[19px] md:left-1/2 top-0 bottom-0 w-px bg-gray-300 -translate-x-1/2"></div>

          <div className="space-y-20 md:space-y-32">
            {steps.map((step, index) => (
              <Reveal key={step.id} delay={index * 0.1}>
                <div className={`flex flex-col md:flex-row items-start md:items-center gap-8 md:gap-0 ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}>

                  <div className={`md:w-1/2 ${index % 2 !== 0 ? 'md:pl-24' : 'md:pr-24'} pl-16 w-full`}>
                    <div className="relative">
                      <span className="text-xs font-bold uppercase tracking-widest text-clever-teal mb-2 block">{t(step.subtitleKey)}</span>
                      <h3 className="text-2xl font-bold text-gray-900 mb-4">{t(step.titleKey)}</h3>
                      <p className="text-gray-500 leading-relaxed">{t(step.descKey)}</p>
                    </div>
                  </div>

                  <div className="absolute left-[19px] md:left-1/2 -translate-x-1/2 flex items-center justify-center">
                    <div className="w-3 h-3 rounded-full bg-clever-teal ring-8 ring-gray-50 z-10"></div>
                  </div>

                  <div className="hidden md:block md:w-1/2" />

                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
